import { TableColumn } from '@maersk-global/mds-components-core/mc-table/types';

export const RepairPartListGridColumns: Array<TableColumn> = [
  {
    id: 'repairMode',
    label: 'Mode',
    dataType: {
      type: 'string',
      formatter: (value) => {
        const stringValue = value as string;
        return stringValue || '';
      },
    },
  },
  {
    id: 'repairCode',
    label: 'Repair Code',
    sortDisabled: true,
  },
  {
    id: 'repairCodeDescription',
    label: 'Repair Code Description',
    sortDisabled: true,
  },
  {
    id: 'partCode',
    label: 'Part Number',
    dataType: {
      type: 'string',
      formatter: (value) => {
        const stringValue = value as string;
        return stringValue || '';
      },
    },
  },
  {
    id: 'partDescription',
    label: 'Part Description',
    sortDisabled: true,
    width: '300px',
  },
  {
    id: 'maxQuantity',
    label: 'Max Part Qty',
    dataType: {
      type: 'number',
    },
    width: '130px',
  },
  {
    id: 'actions',
    label: '',
    sortDisabled: true,
  },
];
